import { useRouter } from 'next/router';

import NavbarLanding from "components/NavbarLanding";
import Footer from "../Footer";
import MainHead from "../main/MainHead";
import { appHostProd } from 'utils/constants';
import config from 'utils/config';

const LandingPageLayout: React.FC<{
  children: React.ReactNode;
  hasLoginToken?: boolean;
  title?: string;
  keywords?: string;
  description?: string;
  titleOg?: string;
  descriptionOg?: string;
  imageUrl?: string;
  hostUrl?: string;
  author?: string;
  type?: string;
}> = ({
  title,
  keywords,
  description,
  children,
  hasLoginToken,
  type,
}) => {
  const domainConfig = config.cookiesConfig.domain;
  const { asPath } = useRouter();
  const fullUrl = `https://${domainConfig}${asPath.replace(/\/$/, '')}`;
  const isMainDomain = domainConfig === appHostProd;
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "OnBoard Crew App",
    "url": fullUrl,
    "logo": "https://www.onboardcrewapp.com/logo.png",
  };

  return (
    <>
      <MainHead
        title={title}
        description={description}
        keywords={keywords}
        robots={isMainDomain ? 'index,follow' : 'noindex,nofollow,noarchive'}
        googleBot={isMainDomain ? 'index,follow' : 'noindex,nofollow,noarchive'}
        schemaJson={schemaData}
      />

      <div className="w-full min-h-screen landing">
        <NavbarLanding
          hasLoginToken={hasLoginToken}
          type={type}
        />
        {children}
        <Footer type={type} />
      </div>
    </>
  );
};

export default LandingPageLayout;
